<div class="p-grid" style="margin : 15px">
     <!-- HEADER -->
     <p-panel [toggleable]="false"  [showHeader]="true" class="p-col-12" styleClass="details">
        <p-header>
            <div class="p-grid">
                <div class="p-col-12" style="margin-bottom: 15px;">
                    <span class="ui-panel-title" style="font-size:16px;display:inline-block;margin-top:2px">LISTE DES BROUILLONS</span>
                </div>             
            </div>
            
        </p-header>
    </p-panel>
    <!-- HEADER -->

    <!-- TABLEAU BROUILLON -->
    <p-table #dt 
        [columns]="brouillonCols" 
        [value]="brouillons" 
        [paginator]="true" [rows]="10" 
        [showCurrentPageReport]="true" styleClass="ui-table-customers" 
        currentPageReportTemplate="Ligne {first} à {last} sur {totalRecords} lignes" 
        [rowsPerPageOptions]="[10,25,50]"
        [rowHover]="true"
    >
   
        <ng-template pTemplate="caption">
            <div style="text-align: right ; margin: 2.5px auto;">
                
            </div>
        </ng-template>

        <ng-template pTemplate="header">
            <tr>
                <th *ngFor="let col of brouillonCols"  [pSortableColumn]="col.field">
                    {{col.header}}
                    <p-sortIcon [field]="col.field" ></p-sortIcon>
                </th>
                <th style="width: 255px;">Remettre dans le lot</th>
            </tr>
            <tr>
                <th *ngFor="let col of brouillonCols" [ngSwitch]="col.field">
                    <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'type_ptl'" [style]="{'width':'100%'}" [options]="typeFilter" defaultLabel="Tous les types" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>
                    
                    <input *ngSwitchCase="'num_point_accueil'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">

                    <p-multiSelect [appendTo]="'body'" *ngSwitchCase="'id_complexite'" [style]="{'width':'100%', 'min-height':'30px'}" [options]="complexteFilter" defaultLabel="Toutes" (onChange)="dt.filter($event.value, col.field, 'in')"></p-multiSelect>

                    <input *ngSwitchCase="'etat'" [style]="{'width':'100%'}" pInputText type="text" (input)="dt.filter($event.target.value, col.field, 'contains')" style="width:auto; min-height:30px;">
                </th>

                <th></th>
            </tr>
        </ng-template>
    
        <ng-template pTemplate="body" let-historique let-columns="columns">
            <tr>
                <td *ngFor="let col of columns" style="text-align: center;" >
                   
                    <ng-template [ngIf]="col.field === 'id_complexite'">
                        <span>
                            {{ getComplexite(historique[col.field]) }}
                        </span>
                    </ng-template>
                    <ng-template [ngIf]="col.field !== 'id_complexite'" > 
                        {{historique[col.field]}}
                    </ng-template>
                </td>
                
                <td align="center"> <p-button   type="button"  icon="pi pi-undo"  class="btn-info" (click)="remettreDansLot(historique['id_moderation'], historique['id_etat'])" ></p-button> </td>
               
            </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="5" style="text-align:center; height: 50px;" >Pas de donnée à afficher.</td>
            </tr>
        </ng-template>
        
    </p-table>
    <!-- FIN TABLEAU BROUILLON -->

</div>
